import { GroupService } from './groupService';
import { HttpService } from 'ah-requests';
1;

export class PartnerGroupService extends GroupService {
  constructor(http: HttpService, baseUrl: string) {
    super(http, `${baseUrl}partner/`, 'partnerGroupService');
  }
}
